<app-data-table mainTitle="Cadastro ECF"
                singleTitle="escrituração"
                routerPath="/cad-ecf"
                entityPath="/cadecf"
                keyField="id"
                [entity]="cadEcf"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
